import { render, staticRenderFns } from "./safetyHat.vue?vue&type=template&id=f45a3f04&scoped=true"
import script from "./safetyHat.vue?vue&type=script&lang=js"
export * from "./safetyHat.vue?vue&type=script&lang=js"
import style0 from "./safetyHat.vue?vue&type=style&index=0&id=f45a3f04&prod&lang=less&scoped=true"
import style1 from "./safetyHat.vue?vue&type=style&index=1&id=f45a3f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45a3f04",
  null
  
)

export default component.exports